// Decides which media a Swatch-Selectable Card shows for a given color.
// Self-contained (no cross-asset imports) to match this theme's module
// convention, where interop happens via window globals. Behaviourally mirrors
// the alt-text "contains" match of color-gallery-filter.js (see ADR-0001).

function altContainsColor(alt, color) {
  if (!alt || !color) return false;
  return alt.toLowerCase().includes(color.toLowerCase());
}

// Returns the id of the Card Hover Image for the selected color, or null.
// The Card Hover Image is the first image-type media whose alt text contains
// the selected color (case-insensitive substring) and whose id differs from
// the primary/featured media. Returns null when none qualifies (no hover swap).
export function resolveCardHoverImageId(mediaItems, selectedColor, featuredMediaId) {
  const match = mediaItems.find(
    (item) =>
      item.type === 'image' &&
      item.id !== featuredMediaId &&
      altContainsColor(item.alt, selectedColor)
  );

  return match ? match.id : null;
}

if (typeof window !== 'undefined') {
  window.CardColorImages = { resolveCardHoverImageId };
}
